import React, { FC } from 'react'
import { Skeleton, SkeletonProps } from '@mui/material'

const EvtSkeleton: FC<SkeletonProps> = ({ children, ...props }) => {
    return <Skeleton {...props}>{children}</Skeleton>
}

export default EvtSkeleton
